import { StringToNumber } from "./utils";

export const normalizeKickbackPercent = (value?: number | null): number => {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return 0;
  }

  return value;
};

export const calculateKickbackAmount = (
  sumExclMoms: string | number,
  kickbackPercent?: number | null,
): number => {
  const sum = typeof sumExclMoms === "number" ? sumExclMoms : StringToNumber(sumExclMoms);
  return sum * (normalizeKickbackPercent(kickbackPercent) / 100);
};

export const calculateKickbackDeduction = (
  originalSum: string | number,
  reportedSum: string | number,
): number => {
  const original = typeof originalSum === "number" ? originalSum : StringToNumber(originalSum);
  const reported = typeof reportedSum === "number" ? reportedSum : StringToNumber(reportedSum);

  return original - reported;
};

export const calculateReportedSumFromDeduction = (
  originalSum: string | number,
  deduction: string | number,
): number => {
  const original = typeof originalSum === "number" ? originalSum : StringToNumber(originalSum);
  const deducted = typeof deduction === "number" ? deduction : StringToNumber(deduction);

  return original - deducted;
};

export const formatKickbackPercent = (value?: number | null): string => {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return "—";
  }

  return `${value.toFixed(1)}%`;
};

export const hasKickbackCommentError = (
  originalSum: number,
  deductionValue: string,
  comment: string,
): boolean => {
  const reportedSum = calculateReportedSumFromDeduction(originalSum, deductionValue);
  const sumsDiffer = originalSum.toFixed(2) !== reportedSum.toFixed(2);
  return sumsDiffer && comment.length === 0;
};
